import {
  Compass,
  Download,
  Film,
  FolderSync,
  HardDrive,
  LayoutDashboard,
  Search,
  Settings,
  Wifi,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
  /** 手机底栏是否展示 */
  mobile?: boolean;
}

/** 全站主导航（侧栏与底栏共用，避免重复定义） */
export const NAV_ITEMS: NavItem[] = [
  { to: "/", label: "今日", icon: LayoutDashboard, end: true, mobile: true },
  { to: "/subscribe", label: "订阅", icon: Film, mobile: true },
  { to: "/discover", label: "发现", icon: Compass, mobile: true },
  { to: "/search", label: "搜索", icon: Search, mobile: true },
  { to: "/download", label: "下载", icon: Download, mobile: true },
  { to: "/transfer", label: "整理", icon: FolderSync },
  { to: "/library", label: "媒体库", icon: HardDrive },
  { to: "/sites", label: "站点", icon: Wifi },
  { to: "/settings", label: "设置", icon: Settings },
];
